// Ingredients screen (`/ingredients`) — thin wrapper over PrereqList.
import PrereqList from './PrereqList';

export default function Ingredients() {
  return <PrereqList kind="ingredients" heading="Ingredients" />;
}
